


export type State = NotLoadedState | LoadingState | LoadErrorState | LoadedState;

export interface NotLoadedState  extends WithApiUrl {
	loadingStep: LoadingStep.NotLoaded
};

export interface LoadingState extends BaseState {
	loadingStep: LoadingStep.Loading
};

export interface LoadErrorState  extends BaseState {
	loadingStep: LoadingStep.LoadError,
	error: string
};

interface WithApiUrl {
	apiUrl: string;
}

interface BaseState extends WithApiUrl {
	b_o: string;
	token: string;
	isNewRow: boolean;
}

export interface LoadedState extends BaseState {
	loadingStep: LoadingStep.Loaded,
	fields: Array<Field>,
	originalTableRow: TableRow,
	tableRow: TableRow,
	tableName: string,
	cssUid: null | string,
	saveResult?: "pending" | {
		status: 'ok' | string,
		ack: boolean
	}
};


export enum LoadingStep {
	NotLoaded,
	Loading,
	LoadError,
	Loaded
};

export type Field = {
	id: string;
	name: string;
	type: string;
	readOnly: 0|1;
	enumColors?: null | EnumColor,
	numformat?: null | string,
	numlang?: null | NumLang,
	required?: true|false|0|1|null,
	[key:string]:any;
};

export type MediaType = 'media' | 'doc' | null;



export type File = {
	id?: string;
    name: string;
    utilisateur_code?: string;
    filesize?: number;
    lastModified?: number;
    type: MediaType;
    url: string;
    gallery?: string;
    preview: string;
};

export type NumLang = 'fr' | 'en' | 'en-gb' | string;

export type Tag = {
	value: string;
	color?: null | string;
	colortext?: null | string;
	mask?: null | string;
}


export interface EnumColor {
	values: Array<Tag>,
	displayColors: 1|0,
	strict: 1|0
};

export type TableRow = {
	[key:string]:any;
};

export type FieldValue = any;



// WEBPACK FOOTER //
// ./src/store/types.ts